import { useState } from 'react';

// Import local images
import haldiDecorImg from '../../assets/images/wedding-categories/haldi-decor.png';
import mehndiDecorImg from '../../assets/images/wedding-categories/mehndi-decor.png';
import brideWelcomeImg from '../../assets/images/wedding-categories/bride-welcome.png';
import NewMendi from '../../assets/images/wedding-categories/freepik__mehndi-art-on-hands-topdown-view-bright-daylight-s__29824.png';
import weddingshower from '../../assets/images/wedding-categories/freepik__the-style-is-candid-image-photography-with-natural__29825.png';
import weedingwelcome from '../../assets/images/wedding-categories/freepik__indian-bride-in-traditional-red-sari-welcomes-gues__29826.png';
import firstnight from '../../assets/images/wedding-categories/freepik__first-night-ceremony-indian-couple-holding-hands-o__29827.png';
const useWeddingCategories = () => {
  const [weddingCategories] = useState([
    {
      id: 1,
      name: "Bridal Shower",
      image: weddingshower,
      gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 50%, #fecfef 100%)",
      icon: "👰",
      description: "Beautiful bridal shower decorations"
    },
    {
      id: 2,
      name: "Haldi Decor",
      image: haldiDecorImg,
      gradient: "linear-gradient(135deg, #ffeaa7 0%, #fab1a0 50%, #fab1a0 100%)",
      icon: "🌼",
      description: "Traditional haldi ceremony decorations"
    },
    {
      id: 3,
      name: "Mehndi Decor",
      image: NewMendi,
      gradient: "linear-gradient(135deg, #74b9ff 0%, #0984e3 50%, #0984e3 100%)",
      icon: "🖐️",
      description: "Elegant mehndi ceremony setup"
    },
    {
      id: 4,
      name: "Wedding Car",
      image: brideWelcomeImg,
      gradient: "linear-gradient(135deg, #fd79a8 0%, #e84393 50%, #e84393 100%)",
      icon: "🚗",
      description: "Stylish wedding car decorations"
    },
    {
      id: 5,
      name: "Bride Welcome",
      image: weedingwelcome,
      gradient: "linear-gradient(135deg, #a29bfe 0%, #6c5ce7 50%, #6c5ce7 100%)",
      icon: "🌹",
      description: "Traditional bride welcome decorations"
    },
    {
      id: 6,
      name: "First Night",
      image: firstnight,
      gradient: "linear-gradient(135deg, #fd79a8 0%, #e84393 50%, #e84393 100%)",
      icon: "🕯️",
      description: "Romantic honeymoon suite setup"
    }
  ]);

  return weddingCategories;
};

export default useWeddingCategories;
